import React from "react";

export const SideContext = React.createContext();